var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryNewsIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 207,
    viewBox: "0 0 174 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 86.8064C174 134.748 103.731 207 87 207C70.2692 207 0 134.748 0 86.8064C0 38.8646 38.9512 0 87 0C135.049 0 174 38.8646 174 86.8064Z",
    fill: "#4BF990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7534 111.212L53.1838 103.427L51.8169 109.012L29.3866 116.797L30.7534 111.212Z",
    fill: "#03152D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7534 122.501L53.1838 114.716L51.8169 120.301L29.3866 128.086L30.7534 122.501Z",
    fill: "#03152D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3152 59.9371C66.3152 58.3493 67.6024 57.0621 69.1902 57.0621H87.1521C88.7399 57.0621 90.0271 58.3493 90.0271 59.9371V75.6538C90.0271 77.2416 88.7399 78.5288 87.1521 78.5288H69.1902C67.6024 78.5288 66.3152 77.2416 66.3152 75.6538V59.9371ZM72.0652 62.8121V72.7788H84.2771V62.8121H72.0652Z",
    fill: "#03152D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9937 63.3048C99.9937 61.717 101.281 60.4298 102.869 60.4298H120.831C122.418 60.4298 123.706 61.717 123.706 63.3048C123.706 64.8927 122.418 66.1798 120.831 66.1798H102.869C101.281 66.1798 99.9937 64.8927 99.9937 63.3048ZM99.9937 73.4084C99.9937 71.8206 101.281 70.5334 102.869 70.5334H120.831C122.418 70.5334 123.706 71.8206 123.706 73.4084C123.706 74.9962 122.418 76.2834 120.831 76.2834H102.869C101.281 76.2834 99.9937 74.9962 99.9937 73.4084Z",
    fill: "#03152D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1246 71.8751C37.1323 71.8751 33.896 75.1114 33.896 79.1037V126.254C33.896 130.246 37.1323 133.482 41.1246 133.482C45.1168 133.482 48.3531 130.246 48.3531 126.254V112.782H54.1031V126.254C54.1031 133.422 48.2924 139.232 41.1246 139.232C33.9567 139.232 28.146 133.422 28.146 126.254V79.1037C28.146 71.9358 33.9567 66.1251 41.1246 66.1251H51.2281V71.8751H41.1246Z",
    fill: "#03152D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.448 50.9287C48.448 40.7213 56.7227 32.4465 66.9301 32.4465H122.063C132.27 32.4465 140.545 40.7213 140.545 50.9287V120.75C140.545 130.958 132.27 139.232 122.063 139.232H41.1245V133.482H122.063C129.094 133.482 134.795 127.782 134.795 120.75V50.9287C134.795 43.8969 129.094 38.1965 122.063 38.1965H66.9301C59.8983 38.1965 54.198 43.8969 54.198 50.9287V115.589H48.448V50.9287Z",
    fill: "#03152D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryNewsIconDefault);
export default __webpack_public_path__ + "static/media/industry-news-icon-default.635d302bb15acef952b12ec9981546e9.svg";
export { ForwardRef as ReactComponent };